<template>

    <body>
        <div class="nav is-accent-primary">
            <div data-duration="400" data-animation="default" data-easing2="ease" data-easing="ease"
                data-collapse="medium" role="banner" data-no-scroll="1" class="nav_container w-nav">
                <div class="nav_left"><a href="#" class="nav_logo w-inline-block">
                        <div class="nav_logo-icon"></div>
                    </a></div>
                <div class="nav_right padding-right_small" v-if="emailVerified">
                    <div><strong v-if="userData">{{ userData.businessName }}</strong></div>
                    <div class="nav_link" @click="logout">Logout</div>
                </div>
                <div class="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0"></div>
            </div>
        </div>
        <div class="heading_h2 margin-top_xlarge padding_small" v-if="!emailVerified">Please Verify Your E-Mail to Gain
            Access to Client Portal</div>
        <header data-copilot="true" class="section overflow_hidden overflow_clip padding_none" v-else>
            <div class="min-height_100dvh padding-top_small">
                <div class="container">
                    <div class="container requests-header">
                        <div class="heading_h2">Customer Information</div>
                        <div class="button radius_medium new-request is-secondary"
                            @click="showChangeContactForm = true">Change Contact Info</div>
                    </div>
                    <div class="card" v-if="!showChangeContactForm && userData">
                        <div class="card_body padding_none">
                            <div class="grid_2-col gap-small padding_xsmall table-row">
                                <div class="request-table-text bold">Name</div>
                                <div class="request-table-text">{{ userData.businessName }}</div>
                            </div>
                            <div class="grid_2-col gap-small padding_xsmall table-row">
                                <div class="request-table-text bold">Contact E-Mail</div>
                                <div class="request-table-text">{{ userData.contactEmail }}</div>
                            </div>
                            <div class="grid_2-col gap-small padding_xsmall table-row">
                                <div class="request-table-text bold">Contact Phone</div>
                                <div class="request-table-text">{{ userData.phoneNumber }}</div>
                            </div>
                            <div class="grid_2-col gap-small padding_xsmall table-row">
                                <div class="request-table-text bold">Address</div>
                                <div class="request-table-text">{{ userData.address }}</div>
                            </div>
                            <div class="grid_2-col gap-small padding_xsmall table-row">
                                <div class="request-table-text bold">Subscription</div>
                                <div class="request-table-text"><a href="#" class="button radius_medium">Open Stripe
                                        Portal</a></div>
                            </div>
                        </div>
                    </div>
                    <div class="form w-form" v-if="showChangeContactForm">
                        <form class="grid_1-col gap-xsmall" aria-label="Email Form">
                            <div class="heading_h2">Contact Info</div>
                            <div>
                                <label for="contact-email">Contact E-Mail</label>
                                <input class="input_field w-input" autofocus="true" maxlength="256"
                                    placeholder="you@yourdomain.ca" type="email" required="" v-model="newContactEmail">
                            </div>
                            <div>
                                <label for="phone">Contact Phone</label>
                                <input class="input_field w-input" autofocus="true" maxlength="256" name="phone"
                                    placeholder="(000) 000-0000 " type="tel" id="phone" required="" v-model="newPhone">
                            </div>
                            <div>
                                <label for="address">Address</label>
                                <input class="input_field w-input" autofocus="true" maxlength="256" name="address"
                                    placeholder="123 Main St, City, Country" type="text" required="" v-model="newAddress">
                            </div>
                            <div class="button radius_medium" @click="changeContactInfo">Save Changes</div>
                            <div class="button radius_medium is-secondary" @click="showChangeContactForm = false">Cancel
                            </div>

                        </form>
                        <div class="w-form-done" tabindex="-1" role="region" aria-label="Email Form success">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail" tabindex="-1" role="region" aria-label="Email Form failure">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="container" v-if="!showChangeContactForm">
                    <div class="container requests-header">
                        <div class="heading_h2">Your Requests</div>
                        <div class="button radius_medium new-request" @click="createNewRequest">Create a New Request</div>
                    </div>
                    <div class="card">
                        <div class="card_body padding_none ">
                            <div class="grid_5-col gap-small padding_xsmall table-row request-table-header">
                                <div class="request-table-text bold">Type</div>
                                <div class="request-table-text bold">Title</div>
                                <div class="request-table-text bold">ID</div>
                                <div class="request-table-text bold">Status</div>
                                <div class="request-table-text light bold">Date Created</div>
                            </div>
                            <div class="grid_5-col gap-small padding_xsmall table-row">
                                <div class="request-table-text type">Logo Design</div>
                                <div class="request-table-text title">New Logo</div>
                                <div class="request-table-text id">16542687345</div>
                                <div class="request-table-text status">New</div>
                                <div class="request-table-text light">8/7/2025 15:24</div>
                            </div>
                            <div class="grid_5-col gap-small padding_xsmall table-row">
                                <div class="request-table-text type">Ad Campaign</div>
                                <div class="request-table-text title">Christmas Event</div>
                                <div class="request-table-text id">62787644590</div>
                                <div class="request-table-text status">In-Progress</div>
                                <div class="request-table-text light">4/6/2025 11:12</div>
                            </div>
                            <div class="grid_5-col gap-small padding_xsmall table-row">
                                <div class="request-table-text type">Website Design</div>
                                <div class="request-table-text title">New Website</div>
                                <div class="request-table-text id">84680875434</div>
                                <div class="request-table-text status">Under Review</div>
                                <div class="request-table-text light">5/5/2025 19:24</div>
                            </div>
                            <div class="grid_5-col gap-small padding_xsmall table-row">
                                <div class="request-table-text type">Business Card</div>
                                <div class="request-table-text title">New Business Card</div>
                                <div class="request-table-text id">63587346976</div>
                                <div class="request-table-text status">Completed</div>
                                <div class="request-table-text light">15/2/2025 07:44</div>
                            </div>
                        </div>
                    </div>
                </div>
                <ul role="list" data-w-id="2bf82215-9922-5959-abd3-161d4209cd62"
                    style="opacity: 1; transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); transform-style: preserve-3d;"
                    class="grid_3-col gap-small position_relative padding_large w-list-unstyled">
                    <li class="margin-bottom_none">
                        <div class="is-large-1x1 margin-bottom_xsmall is-background"><svg
                                xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"
                                fill="none">
                                <path d="M5.25 6.75H18.75V17.25H5.25V6.75Z" stroke="currentColor" stroke-width="1.5"
                                    stroke-linejoin="round"></path>
                                <path d="M5.25 6.75L12 12L18.75 6.75" stroke="currentColor" stroke-width="1.5"
                                    stroke-linejoin="round"></path>
                            </svg></div>
                        <h5 class="heading_h5">Send an email</h5>
                        <p class="text-color_secondary">Share your ideas or ask us anything.</p>
                        <div><a href="#" class="text-link is-secondary">hello@leapdigitalmedia.ca</a></div>
                    </li>
                    <li class="margin-bottom_none">
                        <div class="is-large-1x1 margin-bottom_xsmall is-background"><svg
                                xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"
                                fill="none">
                                <path
                                    d="M12.5 18.25C16.2279 18.25 19.25 15.2279 19.25 11.5C19.25 7.77208 16.2279 4.75 12.5 4.75C8.77208 4.75 5.75 7.77208 5.75 11.5C5.75 12.6007 6.01345 13.6398 6.48072 14.5578L5 19L9.71819 17.6519C10.5664 18.0361 11.5082 18.25 12.5 18.25Z"
                                    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>
                            </svg></div>
                        <h4 class="heading_h5">Give us a call</h4>
                        <p class="text-color_secondary">We’re here Mon–Fri, 8am–5pm PT.</p>
                        <div>+1 (705) 220-2273<br></div>
                    </li>
                    <li class="margin-bottom_none">
                        <div class="is-large-1x1 margin-bottom_xsmall is-background"><svg
                                xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"
                                fill="none">
                                <path
                                    d="M16.3918 14.8527C20.2489 10.9956 17.2769 4.25 12 4.25C6.72299 4.25 3.75102 10.9956 7.60817 14.8527L12 19.25L16.3918 14.8527Z"
                                    stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>
                                <circle cx="12" cy="10.25" r="2" stroke="currentColor" stroke-width="1.5"></circle>
                            </svg></div>
                        <h4 class="heading_h5">Stop by our office</h4>
                        <p class="text-color_secondary">Visit us and meet our creative team.</p>
                        <div>435 Notre Dame Ave,<br>Sudbury, ON, P3C 5K6<br>Canada</div>
                    </li>
                </ul>
            </div>
        </header>
        <footer class="footer">
            <div class="container">
                <div class="w-layout-grid grid_5-col gap-small">
                    <div id="w-node-_851d61a1-1dad-400a-5b6a-92b99f998536-b17c3d94"
                        class="flex_vertical gap-small w-node-_586ae956-1ff0-8a55-6485-7937ed420a75-ed420a72"><a
                            href="#" class="logo w-inline-block">
                            <div class="nav_logo-icon"></div>
                        </a>
                        <ul role="list" aria-label="Social media links"
                            class="footer_icon-group margin_top-auto w-list-unstyled">
                            <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                                    <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%"
                                            viewBox="0 0 16 16">
                                            <path
                                                d="M16,8.048a8,8,0,1,0-9.25,7.9V10.36H4.719V8.048H6.75V6.285A2.822,2.822,0,0,1,9.771,3.173a12.2,12.2,0,0,1,1.791.156V5.3H10.554a1.155,1.155,0,0,0-1.3,1.25v1.5h2.219l-.355,2.312H9.25v5.591A8,8,0,0,0,16,8.048Z"
                                                fill="currentColor"></path>
                                        </svg></div>
                                    <div class="screen-reader">Follow us on Facebook</div>
                                </a></li>
                            <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                                    <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%"
                                            viewBox="0 0 16 16">
                                            <path
                                                d="M8,1.441c2.136,0,2.389.009,3.233.047a4.419,4.419,0,0,1,1.485.276,2.472,2.472,0,0,1,.92.6,2.472,2.472,0,0,1,.6.92,4.419,4.419,0,0,1,.276,1.485c.038.844.047,1.1.047,3.233s-.009,2.389-.047,3.233a4.419,4.419,0,0,1-.276,1.485,2.644,2.644,0,0,1-1.518,1.518,4.419,4.419,0,0,1-1.485.276c-.844.038-1.1.047-3.233.047s-2.389-.009-3.233-.047a4.419,4.419,0,0,1-1.485-.276,2.472,2.472,0,0,1-.92-.6,2.472,2.472,0,0,1-.6-.92,4.419,4.419,0,0,1-.276-1.485c-.038-.844-.047-1.1-.047-3.233s.009-2.389.047-3.233a4.419,4.419,0,0,1,.276-1.485,2.472,2.472,0,0,1,.6-.92,2.472,2.472,0,0,1,.92-.6,4.419,4.419,0,0,1,1.485-.276c.844-.038,1.1-.047,3.233-.047M8,0C5.827,0,5.555.009,4.7.048A5.868,5.868,0,0,0,2.76.42a3.908,3.908,0,0,0-1.417.923A3.908,3.908,0,0,0,.42,2.76,5.868,5.868,0,0,0,.048,4.7C.009,5.555,0,5.827,0,8s.009,2.445.048,3.3A5.868,5.868,0,0,0,.42,13.24a3.908,3.908,0,0,0,.923,1.417,3.908,3.908,0,0,0,1.417.923,5.868,5.868,0,0,0,1.942.372C5.555,15.991,5.827,16,8,16s2.445-.009,3.3-.048a5.868,5.868,0,0,0,1.942-.372,4.094,4.094,0,0,0,2.34-2.34,5.868,5.868,0,0,0,.372-1.942c.039-.853.048-1.125.048-3.3s-.009-2.445-.048-3.3A5.868,5.868,0,0,0,15.58,2.76a3.908,3.908,0,0,0-.923-1.417A3.908,3.908,0,0,0,13.24.42,5.868,5.868,0,0,0,11.3.048C10.445.009,10.173,0,8,0Z"
                                                fill="currentColor"></path>
                                            <path
                                                d="M8,3.892A4.108,4.108,0,1,0,12.108,8,4.108,4.108,0,0,0,8,3.892Zm0,6.775A2.667,2.667,0,1,1,10.667,8,2.667,2.667,0,0,1,8,10.667Z"
                                                fill="currentColor"></path>
                                            <circle cx="12.27" cy="3.73" r="0.96" fill="currentColor"></circle>
                                        </svg></div>
                                    <div class="screen-reader">See us on Instagram<br></div>
                                </a></li>
                            <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                                    <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%"
                                            viewBox="0 0 16 16">
                                            <path
                                                d="M12.3723 1.16992H14.6895L9.6272 6.95576L15.5825 14.829H10.9196L7.26734 10.0539L3.08837 14.829H0.769833L6.18442 8.64037L0.471436 1.16992H5.2528L8.55409 5.53451L12.3723 1.16992ZM11.5591 13.4421H12.843L4.55514 2.48399H3.17733L11.5591 13.4421Z"
                                                fill="currentColor"></path>
                                        </svg></div>
                                    <div class="screen-reader">Connect on X</div>
                                </a></li>
                            <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                                    <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%"
                                            viewBox="0 0 16 16">
                                            <path
                                                d="M15.3,0H0.7C0.3,0,0,0.3,0,0.7v14.7C0,15.7,0.3,16,0.7,16h14.7c0.4,0,0.7-0.3,0.7-0.7V0.7 C16,0.3,15.7,0,15.3,0z M4.7,13.6H2.4V6h2.4V13.6z M3.6,5C2.8,5,2.2,4.3,2.2,3.6c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4 C4.9,4.3,4.3,5,3.6,5z M13.6,13.6h-2.4V9.9c0-0.9,0-2-1.2-2c-1.2,0-1.4,1-1.4,2v3.8H6.2V6h2.3v1h0c0.3-0.6,1.1-1.2,2.2-1.2 c2.4,0,2.8,1.6,2.8,3.6V13.6z"
                                                fill="currentColor"></path>
                                        </svg></div>
                                    <div class="screen-reader">Find us on LinkedIn</div>
                                </a></li>
                            <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                                    <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%"
                                            viewBox="0 0 16 16">
                                            <path
                                                d="M15.8,4.8c-0.2-1.3-0.8-2.2-2.2-2.4C11.4,2,8,2,8,2S4.6,2,2.4,2.4C1,2.6,0.3,3.5,0.2,4.8C0,6.1,0,8,0,8 s0,1.9,0.2,3.2c0.2,1.3,0.8,2.2,2.2,2.4C4.6,14,8,14,8,14s3.4,0,5.6-0.4c1.4-0.3,2-1.1,2.2-2.4C16,9.9,16,8,16,8S16,6.1,15.8,4.8z M6,11V5l5,3L6,11z"
                                                fill="currentColor"></path>
                                        </svg></div>
                                    <div class="screen-reader">Watch on YouTube</div>
                                </a></li>
                        </ul>
                    </div>
                    <ul role="list" id="w-node-_586ae956-1ff0-8a55-6485-7937ed420abb-ed420a72"
                        class="margin-bottom_none w-list-unstyled">
                        <li>
                            <h2 class="heading_h6 text-color_secondary">Company</h2>
                        </li>
                        <li><a href="#" class="footer_link w-inline-block">
                                <div>Pricing</div>
                            </a></li>
                        <li><a href="#" class="footer_link w-inline-block">
                                <div>Services</div>
                            </a></li>
                        <li><a href="#" class="footer_link w-inline-block">
                                <div>Contact</div>
                            </a></li>
                    </ul>
                    <ul role="list" id="w-node-_586ae956-1ff0-8a55-6485-7937ed420ad3-ed420a72"
                        class="margin-bottom_none w-list-unstyled">
                        <li>
                            <h2 class="heading_h6 text-color_secondary">Support</h2>
                        </li>
                        <li><a href="#" class="footer_link w-inline-block">
                                <div>FAQ</div>
                            </a></li>
                        <li><a href="#" class="footer_link w-inline-block">
                                <div>Terms</div>
                            </a></li>
                        <li><a href="#" class="footer_link w-inline-block">
                                <div>Privacy</div>
                            </a></li>
                    </ul>
                </div>
                <div class="divider margin-top_xsmall margin-bottom_xsmall"></div>
                <div class="footer_bottom">
                    <div class="text-color_secondary">© 2025 Leap Digital Media</div>
                </div>
            </div>
        </footer>
        <Loading v-if="isLoading" />
    </body>

</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { auth, db } from '@/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { mapActions } from 'vuex';
import { doc, collection, addDoc, updateDoc  } from 'firebase/firestore';
import Loading from '@/components/loading.vue';

export default {
    name: 'portal',
    data() {
        return {
            showChangeContactForm: false,
            newContactFormSent: false,
            emailVerified: true,
            newPhone: '',
            newAddress: '',
            newContactEmail: '',
            isLoading: false
        }
    },
    components: {
        Loading,
    },
    async mounted() {
        // Check if user is already logged in
        onAuthStateChanged(auth, async (user) => {
            if (user) {
                
                if (user.emailVerified) {
                    this.emailVerified = true;
                    // scroll to the top of the page
                    
                } else {
                    this.emailVerified = false;
                    window.scrollTo(0, 0);
                }
                // Fetch user data from Vuex store
                await this.fetchUserData();
                console.log("User data:", this.userData);
                if (this.userData && !this.userData.enrolled && this.emailVerified) {
                    this.$router.push('/onboarding');
                }
                this.newPhone = this.userData ? this.userData.phoneNumber : '';
                this.newAddress = this.userData ? this.userData.address : '';
                this.newContactEmail = this.userData ? this.userData.contactEmail : '';
            } else {
                this.$router.push('/'); // Redirect to home if user is not signed in
                console.log("No user is signed in.");
            }
        });

    },
    computed: {
        ...mapState(['user', 'isAuthenticated', 'userData']),
    },
    methods: {
        ...mapGetters(['getUserData']),
        ...mapActions(['fetchUserData']),
        async changeContactInfo() {
            // update contact info in firestore
            this.isLoading = true;
            const user = auth.currentUser;
            if (user) {
                const userRef = doc(db, "users/", user.uid);
                await updateDoc(userRef, {
                    address: this.newAddress,
                    phoneNumber: this.newPhone,
                    contactEmail: this.newContactEmail
                }).then(() => {
                    console.log("Contact information updated successfully");
                    this.showChangeContactForm = false; // Hide the form after successful update
                    this.fetchUserData(); // Refresh user data in Vuex store
                }).catch((error) => {
                    console.error("Error updating contact information:", error);
                }).finally(() => {
                    this.isLoading = false;
                });
            }
        },
        createNewRequest() {
            this.$router.push('/request');
            window.scrollTo(0, 0);
        },
        logout() {
            this.isLoading = true;
            auth.signOut().then(() => {
                this.$router.push('/');
            }).catch((error) => {
                console.error("Error signing out:", error);
            }).finally(() => {
                this.isLoading = false;
            });
        }
    }
}
</script>